import {DeviceOrientation} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/viewport/viewportLayout/DeviceOrientation';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class TabletDevice extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, TabletDevice.availableValues);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static TABLET = new AString('Tablet');
    public static IPAD_MINI = new AString('7.9" iPad mini');
    public static IPAD = new AString('10.2" iPad');
    public static IPAD_AIR = new AString('10.5" iPad Air');
    public static IPAD_PRO_11 = new AString('11" iPad Pro');
    public static IPAD_PRO_12 = new AString('12.9" iPad Pro');
    public static NEXUS_7 = new AString('Nexus 7');
    public static NEXUS_9 = new AString('Nexus 9');
    public static NEXUS_10 = new AString('Nexus 10');

    public static availableValues:Array<AString> = [
        TabletDevice.TABLET,
        TabletDevice.IPAD_MINI,
        TabletDevice.IPAD,
        TabletDevice.IPAD_AIR,
        TabletDevice.IPAD_PRO_11,
        TabletDevice.IPAD_PRO_12,
        TabletDevice.NEXUS_7,
        TabletDevice.NEXUS_9,
        TabletDevice.NEXUS_10
    ];

    public static tablet():TabletDevice
    {
        return new TabletDevice(TabletDevice.TABLET);
    }

    public static iPadMini():TabletDevice
    {
        return new TabletDevice(TabletDevice.IPAD_MINI);
    }

    public static iPad():TabletDevice
    {
        return new TabletDevice(TabletDevice.IPAD);
    }

    public static iPadAir():TabletDevice
    {
        return new TabletDevice(TabletDevice.IPAD_AIR);
    }

    public static iPadPro11():TabletDevice
    {
        return new TabletDevice(TabletDevice.IPAD_PRO_11);
    }

    public static iPadPro12():TabletDevice
    {
        return new TabletDevice(TabletDevice.IPAD_PRO_12);
    }

    public static nexus7():TabletDevice
    {
        return new TabletDevice(TabletDevice.NEXUS_7);
    }

    public static nexus9():TabletDevice
    {
        return new TabletDevice(TabletDevice.NEXUS_9);
    }

    public static nexus10():TabletDevice
    {
        return new TabletDevice(TabletDevice.NEXUS_10);
    }

    public static fromString(value:string):TabletDevice
    {
        return new TabletDevice(AString.fromString(value));
    }

    public static getSize(value:AString, orientation:DeviceOrientation):{width:number; height:number}
    {
        let width:number;
        let height:number;

        switch( value.toString() )
        {
            case TabletDevice.TABLET.toString():
            case TabletDevice.IPAD_MINI.toString():
            case TabletDevice.NEXUS_9.toString():
            {
                width = 768;
                height = 1024;
                break;
            }

            case TabletDevice.IPAD.toString():
            {
                width = 810;
                height = 1080;
                break;
            }

            case TabletDevice.IPAD_AIR.toString():
            {
                width = 834;
                height = 1112;
                break;
            }

            case TabletDevice.IPAD_PRO_11.toString():
            {
                width = 834;
                height = 1194;
                break;
            }

            case TabletDevice.IPAD_PRO_12.toString():
            {
                width = 1024;
                height = 1366;
                break;
            }

            case TabletDevice.NEXUS_7.toString():
            {
                width = 600;
                height = 960;
                break;
            }

            case TabletDevice.NEXUS_10.toString():
            {
                width = 800;
                height = 1280;
                break;
            }
        }

        return orientation.isEqualTo(DeviceOrientation.vertical()) ? {width, height} : {width: height, height: width};
    }
}
